import Axios from 'axios';
import * as _ from 'lodash';
import { message } from 'antd';
import Fingerprint from 'fingerprintjs';
import { BASE_URL } from 'constants/Common';

const getsessionUUID = () => {
  const fingerprint = new Fingerprint().get();
  return fingerprint;
};

export const axios = Axios.create({
  baseURL: BASE_URL,
  timeout: 1000 * 60 * 10,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    uuid: getsessionUUID(),
  },
});

export default axios;
